import React from 'react';
import {Modal} from "antd";
import {injectIntl} from "react-intl";
import connect from "react-redux/es/connect/connect";
import withAuthorization from "../../../services/Authorization";
import SAInputLabel from "../../common/input/SAInputLabel";

class SafeCreationModal extends React.Component {

  constructor(props) {
    super(props);
    this.state = {};
  }

  componentWillReceiveProps = (nextProps) => {
    if (nextProps.saveDealerSafe && nextProps.saveDealerSafe.error) {
      const errors = nextProps.saveDealerSafe.error.content || {};
      this.setState({errors})
    }
    if (nextProps.updateDealerSafe && nextProps.updateDealerSafe.error) {
      const errors = nextProps.updateDealerSafe.error.content || {};
      this.setState({errors})
    }
  };

  componentDidMount() {
    const {selectedSafe} = this.props;

    if (selectedSafe) {
      this.setState({...selectedSafe})
    }
  }

  onSafeSave = () => {
    const {selectedMode, selectedSafe = {}} = this.props;
    const {id} = selectedSafe;
    selectedMode === 'create' ? this.props.dispatchSaveDealerSafe(this.state) : this.props.dispatchUpdateDealerSafe(id, this.state);
  };

  onSafeChange = (e) => {
    const {target: {name, value}} = e;
    this.setState({[name]: value});
  };

  render() {
    const {intl: {formatMessage}, saveDealerSafe: {showModal}} = this.props;
    const {safeNumber, safeCode} = this.state;
    const errors = this.state.errors || {};

    return (
      <Modal title={formatMessage({id: 'section.safe-creation.modal.title'})}
             visible={showModal} onCancel={this.props.hideSafeModal}
             footer={[
               <button key="save" type="primary" className="btn btn-sm btn-primary" onClick={this.onSafeSave}>{formatMessage({id: 'action.save'})}</button>
             ]}>
        <div className="row">
          <ul className="list">
            <li>
              <SAInputLabel name="safeNumber" onChange={this.onSafeChange} value={safeNumber}
                            label="safe.number" maxLength={15} error={errors.safeNumber}/>
            </li>
            <li>
              <SAInputLabel name="safeCode" onChange={this.onSafeChange} value={safeCode}
                            label="safe.code" maxLength={15} error={errors.safeCode}/>
            </li>
          </ul>
        </div>
      </Modal>
    )
  }
}

const mapStateToProps = state => ({
  saveDealerSafe: state.saveDealerSafe,
  updateDealerSafe: state.updateDealerSafe
});

const mapDispatchToProps = dispatch => ({
  dispatchSaveDealerSafe: (body) => dispatch({type: 'SAVE_DEALER_SAFE.REQUEST', body}),
  dispatchUpdateDealerSafe: (id, body) => dispatch({type: 'UPDATE_DEALER_SAFE.REQUEST', id, body}),
  showSafeModal: () => dispatch({type: 'SHOW_SAFE_MODAL'}),
  hideSafeModal: () => dispatch({type: 'HIDE_SAFE_MODAL'})
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withAuthorization(injectIntl(SafeCreationModal), ['DUI_ADMIN', 'DUI_SERVICE_ADVISOR']));



// WEBPACK FOOTER //
// ./src/components/safes/management/SafeCreationModal.js